
import SectionModel from "../../models/sectionModel";
import { PAYMENTS_CONFIGURATION_SETTING, PROVIDER_SETTING_GET, RESTAURANT_PAYME_WALLET_SETTING } from "../../store/reducers/restaurant/restaurant-actions";
import {
  CONTROL_TYPE,
  MARKETPLACE_SETTINGS_MODEL, MODEL_CONTROL_TYPE,
  PAYMENT_PROVIDER,
  paymentProviders,
  sellerBankCodes,
  sellerIncList,
  sellerPersonBusinessTypes,
  TYPE_SECTION_MODEL
} from "../../utils/enums";
import { checkPrivaryRequired } from "../../utils/sectionModelHelper";
import { createControlModel } from "../controlModelFactory";
import { createBreadcrumbModel } from "../createBreadcrumbModel";
import { isMobileWidth } from "../restaurant";

export function createPaymentsConfigurationSettingsSectionModel({ ...args }) {
  return new SectionModel({
    columns: [
      {
        title: "settings.paymentsConfigurationSettings.MAIN_TAB",
        isEditable: true,
        type: CONTROL_TYPE.sectionTab,
        items: [
          {
            title: "settings.paymentsConfigurationSettings.OVERRIDE_DEPOT_SETTINGS_LABEL",
            accessor: "overrideDepotSettings",
            isEditable: true,
            type: CONTROL_TYPE.switch,
            isInline: true,
          },
          {
            title: "settings.paymentsConfigurationSettings.ACCEPT_CREDIT_CARD",
            accessor: "acceptCreditCard",
            isEditable: true,
            type: CONTROL_TYPE.checkbox
          },
          {
            title: "settings.paymentsConfigurationSettings.ACCEPT_CREDIT_CARD",
            accessor: "paymeWalletExist",
            isEditable: true,
            type: CONTROL_TYPE.paymeConfiguration
          },
          {
            title: "settings.paymentsConfigurationSettings.ACCEPT_CASH",
            accessor: "acceptCash",
            isEditable: true,
            type: CONTROL_TYPE.checkbox
          },
          // for empty item on the left
          { accessor: 'empty1' },
          {
            title: "settings.paymentsConfigurationSettings.ACCEPT_CASH_ON_TAKEAWAY",
            accessor: "acceptCashOnTakeAway",
            isEditable: true,
            type: CONTROL_TYPE.checkbox
          },
          { accessor: 'empty2' },
          {
            title: "settings.paymentsConfigurationSettings.ACCEPT_EXTERNAL_PAYMENT",
            accessor: "acceptExternalPayment",
            isEditable: true,
            type: CONTROL_TYPE.checkbox
          }
        ]
      },
      {
        title: "settings.paymentsConfigurationSettings.CONFIG_TAB",
        isEditable: true,
        accessor: "config",
        type: CONTROL_TYPE.sectionTab,
        items: [
          {
            title: 'settings.paymentsConfigurationSettings.PROVIDER',
            accessor: 'provider',
            isEditable: true,
            connect: () => ({
              values: paymentProviders(),
            }),
            type: CONTROL_TYPE.select,
          },
          {
            title: 'settings.paymentsConfigurationSettings.TRANZILLA_TOKEN_TERMINAL_NAME',
            accessor: 'tranzillaTokenTerminalName',
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.Tranzila,
            type: CONTROL_TYPE.text,
          },
          {
            title: 'settings.paymentsConfigurationSettings.TRANZILLA_TERMINAL_PASSWORD',
            accessor: 'tranzillaTerminalPassword',
            ...checkPrivaryRequired('tranzillaTerminalPassword', PAYMENT_PROVIDER.Tranzila),
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.Tranzila,
            type: CONTROL_TYPE.text,
            inputType: "password"
          },
          {
            title: 'settings.paymentsConfigurationSettings.TRANZILLA_TERMINAL_NAME',
            accessor: 'tranzillaTerminalName',
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.Tranzila,
            type: CONTROL_TYPE.text,
          },
          {
            title: 'settings.paymentsConfigurationSettings.TRANZILLA_TERMINAL_3DS_NAME',
            accessor: 'tranzillaTerminal3dsName',
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.Tranzila,
            type: CONTROL_TYPE.text,
          },
          {
            title: 'settings.paymentsConfigurationSettings.TRANZILLA_PUBLIC_KEY',
            accessor: 'tranzillaPublicKey',
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.Tranzila,
            type: CONTROL_TYPE.text,
          },
          {
            title: 'settings.paymentsConfigurationSettings.TRANZILLA_SECRET',
            accessor: 'tranzillaSecret',
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.Tranzila,
            type: CONTROL_TYPE.text,
            ...checkPrivaryRequired('tranzillaSecret', PAYMENT_PROVIDER.Tranzila),
            inputType: "password"
          },
          {
            title: 'settings.paymentsConfigurationSettings.DC_DISABLE',
            accessor: 'dcDisable',
            isEditable: true,
            isInline: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.Tranzila,
            type: CONTROL_TYPE.switch,
          },
          {
            title: 'settings.paymentsConfigurationSettings.PAYME_CLIENT_KEY',
            accessor: 'payMeClientKey',
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.PayMe,
            type: CONTROL_TYPE.text,
          },
          {
            title: 'settings.paymentsConfigurationSettings.PAYME_SELLER_ID',
            accessor: 'paymeSellerId',
            isEditable: true,
            isShow: item => item?.provider === PAYMENT_PROVIDER.PayMe,
            type: CONTROL_TYPE.text,
          },
          {
            title: 'settings.paymentsConfigurationSettings.PAYME_SECRET',
            accessor: 'paymeSecret',
            isShow: item => item?.provider === PAYMENT_PROVIDER.PayMe,
            ...checkPrivaryRequired('paymeSecret', PAYMENT_PROVIDER.PayMe),
            isEditable: true,
            type: CONTROL_TYPE.text,
            inputType: "password"
          },
          {
            title: 'settings.paymentsConfigurationSettings.STRIPE_KEY',
            accessor: 'stripeKey',
            isEditable: true,
            ...checkPrivaryRequired('stripeKey', PAYMENT_PROVIDER.Stripe),
            isShow: item => item?.provider === PAYMENT_PROVIDER.Stripe,
            type: CONTROL_TYPE.text,
            inputType: "password"
          },
          {
            title: 'settings.paymentsConfigurationSettings.PUBLIC_STRIPE_KEY',
            accessor: 'publicStripeKey',
            isShow: item => item?.provider === PAYMENT_PROVIDER.Stripe,
            isEditable: true,
            type: CONTROL_TYPE.text,
          }
        ]
      },
    ],
    actionLoad: PROVIDER_SETTING_GET,
    actionName: PAYMENTS_CONFIGURATION_SETTING,
    initNewItemModel: item => item,
    typeAction: args.typeAction,
    stayAfterSave: true,
    typeModel: MARKETPLACE_SETTINGS_MODEL.paymentsConfiguration,
    saveControlsConfig: {
      cancel: { title: "basic.RESET_BUTTON", action: () => { }, isInit: true }
    },
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth
      })
    ],
    breadcrumbs: [
      createBreadcrumbModel({
        label: "header.menu.MARKETPLACE_SETTINGS",
      }),
    ],
    label: "settings.paymentsConfigurationSettings.LABEL",
    mappingLambda: state => ({ 
      id: "paymentsConfiguration", 
      ...state.restaurant.data.paymentsConfiguration, 
      config: state.restaurant.data.paymentsConfiguration.config,
      configDefault: state.restaurant.data.paymentsConfiguration.config,
    })
  });
}

export function createRestaurantPaymeWalletNewSectionModel({ ...args }) {
  return new SectionModel({
    columns: [
      {
        title: "settings.paymeWallet.SELLER_FIRST_NAME",
        accessor: "sellerFirstName",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_LAST_NAME",
        accessor: "sellerLastName",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_SOCIAL_ID",
        accessor: "sellerSocialId",
        minLength: 9,
        maxLength: 9,
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_BANK_CODE",
        accessor: "sellerBankCode",
        connect: () => ({
          values: sellerBankCodes()
        }),
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.select
      },
      {
        title: "settings.paymeWallet.SELLER_BANK_BRANCH",
        accessor: "sellerBankBranch",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.number
      },
      {
        title: "settings.paymeWallet.SELLER_BANK_ACCOUNT_NUMBER",
        accessor: "sellerBankAccountNumber",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_EMAIL",
        accessor: "sellerEmail",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_PHONE",
        accessor: "sellerPhone",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_BIRTHDAY",
        accessor: "sellerBirthdate",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.date
      },
      {
        title: "settings.paymeWallet.SELLER_SOCIAL_ID_ISSUED",
        accessor: "sellerSocialIdIssued",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.date
      },
      {
        title: "settings.paymeWallet.SELLER_GENDER",
        label: {
          onLabel: "Female",
          offLabel: "Male",
        },
        accessor: "sellerGender",
        isEditable: true,
        type: CONTROL_TYPE.switch
      },
      {
        title: "settings.paymeWallet.SELLER_INC",
        accessor: "sellerInc",
        connect: () => ({
          values: sellerIncList()
        }),
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.select
      },
      {
        title: "settings.paymeWallet.SELLER_MERCHANT_NAME",
        accessor: "sellerMerchantName",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_INC_CODE",
        accessor: "sellerIncCode",
        isEditable: true,
        isFuncRequired: function (item) {
          return !!item.sellerInc
        },
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_PERSON_BUSINESS_TYPE",
        accessor: "sellerPersonBusinessType",
        connect: () => ({
          values: sellerPersonBusinessTypes()
        }),
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.select
      },
      {
        title: "settings.paymeWallet.SELLER_SITE_URL",
        accessor: "sellerSiteUrl",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_ADDRESS_CITY",
        accessor: "sellerAddressCity",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_ADDRESS_STREET",
        accessor: "sellerAddressStreet",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "settings.paymeWallet.SELLER_ADDRESS_STREET_NUMBER",
        accessor: "sellerAddressStreetNumber",
        isEditable: true,
        isRequired: true,
        type: CONTROL_TYPE.text
      }
    ],
    actionName: RESTAURANT_PAYME_WALLET_SETTING,
    initNewItemModel: () => ({
      sellerFirstName: "",
      sellerLastName: "",
      sellerSocialId: "",
      sellerBankCode: 0,
      sellerBankBranch: 0,
      sellerBankAccountNumber: "",
      sellerEmail: "",
      sellerPhone: "",
      sellerBirthdate: "",
      sellerSocialIdIssued: "",
      sellerGender: false,
      sellerInc: 0,
      sellerMerchantName: "",
      sellerIncCode: "",
      sellerPersonBusinessType: 0,
      sellerSiteUrl: "",
      sellerAddressCity: "",
      sellerAddressStreet: "",
      sellerAddressStreetNumber: ""
    }),
    typeAction: args.typeAction,
    typeModel: TYPE_SECTION_MODEL.restaurantPaymeWalletNew,
    parentUrl: MARKETPLACE_SETTINGS_MODEL.paymentsConfiguration,
    stayAfterSave: true,
    saveControlsConfig: {
      cancel: {
        action: (item, history) => {
          history.push(MARKETPLACE_SETTINGS_MODEL.paymentsConfiguration);
        }
      }
    },
    mappingLambda: () => []
  });
}
